import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const ifPath = (path) => {
  let pathname = undefined;
  if (path && path.split("/") && path.split("/").length > 1) {
    pathname = path.split("/")[1];
  }
  return pathname;
};

const ifUI = () => {
  const { location } = window;
  return location.host === "www.ui.com" || location.host === "ui.com";
};

const ifOperator = () => {
  const { location } = window;
  return ifPath(location.pathname) === "uisp";
};

ReactGA.initialize(
  [
    {
      trackingId: "UA-2432820-36", // unifi tracking id
      gaOptions: {
        name: "unifi",
      },
    },
    {
      trackingId: "UA-2432820-78", // operator tracking id
      gaOptions: { name: "operator" },
    },
  ],
  { debug: false, alwaysSendToDefaultTracker: false },
);

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    if (ifUI() && !ifOperator()) {
      ReactGA.set(
        {
          anonymizeIp: true,
          page,
          ...options,
        },
        ["unifi"],
      );
      ReactGA.pageview(page, ["unifi"]);
    }

    if (ifUI() && ifOperator()) {
      ReactGA.set(
        {
          anonymizeIp: true,
          page,
          ...options,
        },
        ["operator"],
      );
      ReactGA.pageview(page, ["operator"]);
    }
  };

  const HOC = (props) => {
    const location = useLocation();

    useEffect(() => {
      setTimeout(() => {
        const page = location.pathname + location.search;
        trackPage(page);
      }, 1000);
    }, [location.pathname, location.search]);

    return <WrappedComponent {...props} />;
  };

  return HOC;
};

export default withTracker;
